// extracted by mini-css-extract-plugin
export default {"wrapper":"FlexibleDepositPlan_wrapper__xR0LE","container":"FlexibleDepositPlan_container__DhaL9","header":"FlexibleDepositPlan_header__XtHi1"};